export const APP_NAME = 'Precision Trader';
export const VERSION = '0.3.1';
export const VERSION_DATE = '2026-01-26';

export const CHANGELOG_CONTENT = `
## v0.3.1
(2026-01-26)
*SnapTrade conversion*
- Moved from direct Public.com integration to utilizing SnapTrade in order to support more brokers
- Added settings to Buy Panel to enable consistent position sizing
- Small improvements to existing UI

## v0.3
(2026-01-05)  
*Massive security overhaul and project-wide refactor*
- Added industry-standard login flow for authentication and authorization
- Added new backend database with additional at-rest encryption
- Foundational code refactor to support ongoing development and feature expansion
- Terms of Service now state collection of email address and IP
- Fixed display issues when changing an order's reference type
- Fixed issue where browser would not get latest updates without hard refresh

## v0.2.3
(2025-12-12)
- Added Bracket orders, usable with all price references
- Added warning if user tries to enter an incorrect value for login "secret"
- Renamed Account page to Dashboard
- Added Settings panel to Dashboard
    - Added button to view version changelog

## v0.2.2
(2025-12-11)
- Removed "Last Price" from order details since it shows on position now
- Fixed positions sometimes reshowing after clicking "Hide" on them
- Fixed incorrect DTE labels on positions


## v0.2.1
(2025-12-08)
- Added a position's current contract price beside its average price
`;